@if (entitySelectionCollection.length > 0 && selectedEntity) {
  <div class="container-fluid g-0">
    @if (entitySelectionCollection.length > 1) {
      <div class="row row-padding">
        <div class="col-auto form-group">
          <label
            >{{ getRegistrationTypeToEntitySelectionText() }} Selection</label
          >
          <select
            class="form-select"
            [(ngModel)]="selectedEntity"
            (change)="entitySelection(selectedEntity)"
          >
            @for (selection of entitySelectionCollection; track selection) {
              <option [ngValue]="selection">
                {{ selection.label }}
              </option>
            }
          </select>
        </div>
      </div>
    }
    @if (logo) {
      <div class="row row-padding">
        <img src="{{ logo }}" alt="logo_image" />
      </div>
    }
    <div class="row row-padding">
      <h3>Registration Progress</h3>
    </div>
    @if (!disableView) {
      <div class="row row-padding">
        <p>
          To make edits to any information you've entered, please click on the
          green step below.
        </p>
      </div>
    }
    <div class="row row-padding">
      @for (step of RegistrationSteps; track step) {
        @if (
          stepNameToLabelMap[step.type!] &&
          stepNameToLabelMap[step.type!][step.name!]
        ) {
          <div class="tracker-part-container col-md-12">
            <div class="row">
              <div class="col-auto d-flex flex-column">
                <div
                  class="tracker-bar flex-grow-1"
                  [ngClass]="getProgressStatusClass(step)"
                ></div>
                <div
                  class="tracker-dot"
                  [ngClass]="getProgressStatusClass(step)"
                ></div>
              </div>
              <div class="col">
                @if (!disableView) {
                  <label
                    class="tracker-label selection"
                    [ngClass]="getProgressStatusClass(step)"
                    (click)="goToStep(step)"
                    >{{ processRegistrationStepText(step) }}</label
                  >
                }
                @if (disableView) {
                  <label
                    class="tracker-label"
                    [ngClass]="getProgressStatusClass(step)"
                    >{{ processRegistrationStepText(step) }}</label
                  >
                }
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
}
